export default __webpack_public_path__ + "static/media/ss-cr8ed.6bf2a18f.png";